import {
    FETCH_RESOURCE_LOADING,
    FETCH_RESOURCE_LOADED,
    FETCH_RESOURCE_ERROR,
} from '../actions/auxiliar_actions'

import {
    FETCH_GET_IFRAME_DATA_SUCCESS
} from '../actions/iframe_actions'

export default (state = {}, action) => {
    switch(action.type){
        case FETCH_RESOURCE_LOADING: {
            return {...state, loading: state.loading + 1}
        }
        case FETCH_RESOURCE_LOADED: {
            return {...state, loading: true}
        }
        case FETCH_RESOURCE_ERROR: {
            return {...state, fetchError: action.payload, loading: false}
        }
        case FETCH_GET_IFRAME_DATA_SUCCESS: {
            return {...state, ...action.payload, fetchError: null}
        }
        default: {
            return state
        }
    }
}